module.exports = __webpack_public_path__ + "img/avatar_f.3a7dd4f0.jpg";